import React from 'react';
import { CheckIcon, TrophyIcon, XIcon } from 'lucide-react';
import { Medallion } from './Medallion';
import { heroBenefits, notThis, productName, solutionPillars } from '../data/copy';
export function SolutionSection() {
  return <section className="defer-paint w-full border-y border-line bg-canvas py-10 sm:py-20" aria-labelledby="solution-heading" data-id="element-226" data-mp="3oa3l1vmyl59w">
      <div className="mx-auto max-w-4xl px-5 text-center sm:px-6" data-id="element-227" data-mp="3jcae30du078k">
        <Medallion icon={TrophyIcon} data-id="element-228" data-mp="139sz2wl3jsh" />
        <h2 id="solution-heading" className="mt-4 font-display text-2xl font-bold leading-tight text-navy sm:text-4xl" data-id="element-229" data-mp="1287s5lutgx1">
          The Complete Track &amp; Field Coaching System
        </h2>
        <p className="mt-2 text-sm font-semibold text-gold-text sm:text-lg" data-id="element-230" data-mp="awi7y9h1fjib">
          {productName} · 6 volumes · 150+ sessions · 5 command kits
        </p>

        <div className="mt-7 grid gap-4 text-left md:grid-cols-2" data-id="element-231" data-mp="ktmyelhx214x">
          <ul className="space-y-2.5 rounded-2xl border border-line bg-white p-5" data-id="element-232" data-mp="ftqvkpkygfqy">
            {notThis.map(line => <li key={line} className="flex items-start gap-2.5 text-sm leading-relaxed text-body" data-id="element-233" data-mp="36b5jowij3aet">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-signal" strokeWidth={2.5} aria-hidden="true" data-id="element-234" data-mp="3b9735ijv9bqt" />
                {line}
              </li>)}
          </ul>
          <div className="rounded-2xl bg-navy p-5" data-id="element-235" data-mp="3fdn6pd60c72v">
            <p className="text-sm font-semibold text-white" data-id="element-236" data-mp="3kbg9rxc0kkyx">It gives you:</p>
            <ul className="mt-3 space-y-2" data-id="element-237" data-mp="3p9zy24e2y8ug">
              {heroBenefits.map(benefit => <li key={benefit} className="flex items-start gap-2.5 text-sm leading-relaxed text-white" data-id="element-238" data-mp="3p7ngvtg5c2ig">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-239" data-mp="2tvnkdn572o0" />
                  {benefit}
                </li>)}
            </ul>
          </div>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-240" data-mp="butvh70pbubv">
          {solutionPillars.map(pillar => <li key={pillar.want} className="rounded-full border border-line bg-white px-3 py-1 text-xs font-bold text-navy sm:text-sm" data-id="element-241" data-mp="gtey1d3feq3h">
              {pillar.want}
            </li>)}
        </ul>
      </div>
    </section>;
}